import React from 'react';
import PropTypes from 'prop-types';

const JobMessageItem = ({ command }) => (
  <div className="flex flex-col mt-0.5 mb-0.5 pt-0.5 pb-0.5 pl-1 pr-1 bg-white text-gray-900 cursor-pointer justify-center">
    <div className="pl-4 font-black overflow-ellipsis whitespace-nowrap overflow-hidden">
      { command.message }
    </div>
  </div>
);

JobMessageItem.propTypes = {
  command: PropTypes.object.isRequired,
};

export default JobMessageItem;
